/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { FindProductsCatalogRequestFiltersDto } from "./FindProductsCatalogRequestFiltersDto.ts"

export const generateExportByKeyRequestDtoKeyEnum = {
  EXPORT_PRODUCTS_IKKS: "EXPORT_PRODUCTS_IKKS",
  EXPORT_PRODUCTS_CHANTELLE: "EXPORT_PRODUCTS_CHANTELLE",
  EXPORT_PRODUCTS_GENERIC: "EXPORT_PRODUCTS_GENERIC",
  EXPORT_STANDARDS_GENERIC: "EXPORT_STANDARDS_GENERIC",
  EXPORT_STANDARDS_JONAK: "EXPORT_STANDARDS_JONAK",
  EXPORT_PRODUCTION_SITES_GENERIC: "EXPORT_PRODUCTION_SITES_GENERIC",
  EXPORT_PRODUCTION_SITES_JONAK: "EXPORT_PRODUCTION_SITES_JONAK",
  EXPORT_ADEME_ENV_LABELLING_CLAIMS: "EXPORT_ADEME_ENV_LABELLING_CLAIMS",
  EXPORT_PRODUCTS_JONAK: "EXPORT_PRODUCTS_JONAK",
  EXPORT_PRODUCTS_LOLA_LIZA: "EXPORT_PRODUCTS_LOLA_LIZA",
  EXPORT_CATALOG: "EXPORT_CATALOG",
} as const

export type GenerateExportByKeyRequestDtoKeyEnumKey =
  (typeof generateExportByKeyRequestDtoKeyEnum)[keyof typeof generateExportByKeyRequestDtoKeyEnum]

export type GenerateExportByKeyRequestDto = {
  /**
   * @type string
   */
  key: GenerateExportByKeyRequestDtoKeyEnumKey
  /**
   * @type object | undefined
   */
  filters?: FindProductsCatalogRequestFiltersDto
}
